import { render } from "./Solucao.vue?vue&type=template&id=4e1709a1"
import script from "./Solucao.vue?vue&type=script&lang=js"
export * from "./Solucao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__